import React from 'react';
import Icons from 'components/icons';

const GraphicStandShelfField = ({ stand }) => {
    if (!stand?.shelf_number) {
        return <strong>&mdash;</strong>;
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            color: 'rgba(248, 220, 0, 1)',
            fontSize: '22px'
        }}>
            <Icons.Shelf />
            <span style={{
                fontWeight: 'bold',
                fontSize: '14px'
            }}>
                {stand.shelf_number}
            </span>
        </div>
    );
};

export default GraphicStandShelfField;
